module.exports = __webpack_public_path__ + "img/lawjudgeback.108c4713.png";